var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orders.length
    ? _c("div", { staticClass: "last-orders" }, [
        _c("h2", {
          staticClass: "last-orders__title",
          domProps: { innerHTML: _vm._s(_vm.$t("shoplist.lastOrders.title")) }
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "last-orders__list" },
          _vm._l(_vm.orders, function(order) {
            return _c("LastOrdersItem", {
              key: order.tokenValue,
              attrs: { order: order },
              on: {
                click: function($event) {
                  return _vm.$emit("click", order.tokenValue)
                }
              }
            })
          }),
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }